import React, { ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import { CardListItemSubComponentProps, wrapCardListItemSubComponent, WrappedCardListItemSubComponent } from '../CardListItem/cardListItemSubComponent';
import styles from './CardListItemStatusIcons.module.css';
export type CardListItemStatusIconsProps = ComponentProps<'div'> & CardListItemSubComponentProps<Record<never, never>>;
export const CardListItemStatusIcons: WrappedCardListItemSubComponent<CardListItemStatusIconsProps> = wrapCardListItemSubComponent(props => {
  const {
    children,
    className,
    ...remainingProps
  } = prepareProps({
    props,
    filter: ['cardListItemInfo']
  });
  const hasChildren = React.Children.count(children) > 0;
  return <div {...remainingProps} className={classes(className, styles.wrapper, hasChildren ? styles.hasChildren : null)}>
        {children}
      </div>;
});